export default "__VITE_ASSET__4d61da75__"